import type { MessageCatalog } from './entry';

/** The account dialog: identity, password, address confirmation, language. */
export const account = {
  'account.title': { en: 'Your account', nl: 'Je account' },
  'account.changePassword': { en: 'Change password', nl: 'Wachtwoord wijzigen' },
  'account.passwordChanged': {
    en: 'Password changed. Other sessions have been signed out.',
    nl: 'Wachtwoord gewijzigd. Andere sessies zijn afgemeld.',
  },
  'account.passwordChangeFailed': {
    en: 'Could not change the password.',
    nl: 'Het wachtwoord kon niet worden gewijzigd.',
  },
  'account.signedInAs': { en: 'Signed in as', nl: 'Ingelogd als' },
  'account.roleIn': {
    en: (role: string, workspace: string) => ` — ${role} in ${workspace}`,
    nl: (role: string, workspace: string) => ` — ${role} in ${workspace}`,
  },
  'account.otherWorkspaces': {
    en: (n: number) =>
      `This account also opens ${n} other workspace${n > 1 ? 's' : ''}. Your password is the same in all of them.`,
    nl: (n: number) =>
      `Met dit account open je ook nog ${n} andere werkruimte${n > 1 ? 's' : ''}. Je wachtwoord is overal hetzelfde.`,
  },
  'account.unconfirmed': {
    en: 'This address has not been confirmed. Until it is, Wellformed cannot send you a reset link if you are ever locked out.',
    nl: 'Dit adres is nog niet bevestigd. Tot die tijd kan Wellformed je geen herstellink sturen als je ooit niet meer kunt inloggen.',
  },
  'account.sendConfirmation': {
    en: 'Send me a confirmation link',
    nl: 'Stuur mij een bevestigingslink',
  },
  'account.confirmationSent': {
    en: (email: string) => `Confirmation sent to ${email}.`,
    nl: (email: string) => `Bevestiging verstuurd naar ${email}.`,
  },
  'account.currentPassword': { en: 'Current password', nl: 'Huidig wachtwoord' },
  'account.newPassword': { en: 'New password', nl: 'Nieuw wachtwoord' },
  'account.confirmNewPassword': { en: 'Confirm new password', nl: 'Bevestig nieuw wachtwoord' },
  'account.tooShort': { en: 'At least 10 characters.', nl: 'Minstens 10 tekens.' },
  'account.mismatch': { en: 'These do not match.', nl: 'Deze komen niet overeen.' },
  'account.signsOutOthers': {
    en: 'Changing your password signs out every other session, including any you have forgotten about.',
    nl: 'Als je je wachtwoord wijzigt, worden alle andere sessies afgemeld — ook de sessies die je bent vergeten.',
  },
} as const satisfies MessageCatalog;
